import axios from 'axios'
import store from '@/store'
async function downloadArchive(urlArchive, name = '', headers = {
    Authorization: `Bearer ${store.state.user.token}`
}) {
    try {
        const result = await axios({
            url: `${urlArchive}`,
            method: 'GET',
            responseType: 'blob',
            headers,
        })
        console.log(result)
        const url = window.URL.createObjectURL(result.data);
        const selector = document.createElement('a');
        selector.href = url;
        let nameSplited = urlArchive.split('/')
        nameSplited = nameSplited[nameSplited.length - 1].split('.')
        selector.download = name == '' ? nameSplited[0] : name;
        selector.click();
        return result.data.ok
    } catch (error) {
        return error
    }
}

export default downloadArchive